import { useSelector } from 'react-redux';
import { selectDocsFormData } from '../../redux-state/selectors';
import { PLATE_TYPE, TRANSACTION_TYPE_MAP } from '../docs/constants';

function TransactionInformation() {
  const docsFormData = useSelector(selectDocsFormData)

  return (
    <div>
      <div className='border-t-2 border-t-gray-100 mb-3'>
        <div className='text-gray-700 mt-6 font-bold'>
          Transaction Information
        </div>
      </div>

      <div className='flex flex-col lg:flex-row w-full gap-6 lg:gap-24 mb-6'>
        <div className='flex flex-col w-[100%] text-gray-700 gap-2'>
          {TRANSACTION_TYPE_MAP?.[docsFormData?.transactionType] && (
            <div className='flex flex-row justify-between'>
              <div>
                Transaction Type:
              </div>
              <div className='font-medium'>
                {TRANSACTION_TYPE_MAP[docsFormData.transactionType]}
              </div>
            </div>
          )}

          {docsFormData?.transactionDate &&
            <div className='flex flex-row justify-between'>
              <div>
                Transaction Date:
              </div>
              <div className='font-medium'>
                {docsFormData?.transactionDate}
              </div>
            </div>
          }

          <div className='flex flex-row justify-between'>
            <div>
              Military:
            </div>
            <div className='font-medium'>
              {docsFormData?.military ? "Yes": "No"}
            </div>
          </div>

          {docsFormData?.plateNumber &&
            <div className='flex flex-row justify-between'>
              <div>
                Plate Number:
              </div>
              <div className='font-medium'>
                {docsFormData?.plateNumber}
              </div>
            </div>
          }

          {docsFormData?.docsFees &&
            <div className='flex flex-row justify-between'>
              <div>
                Doc Fees:
              </div>
              <div className='font-medium'>
                {Number(docsFormData?.docsFees || 0).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              </div>
            </div>
          }

          {docsFormData?.insurancePackages &&
            <div className='flex flex-row justify-between'>
              <div>
                Insurance Packages:
              </div>
              <div className='font-medium'>
                {Number(docsFormData?.insurancePackages || 0).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              </div>
            </div>
          }

          {docsFormData?.protectionPackages &&
            <div className='flex flex-row justify-between'>
              <div>
                Theft Protection:
              </div>
              <div className='font-medium'>
                {Number(docsFormData?.protectionPackages || 0).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              </div>
            </div>
          }

          <div className='flex flex-row justify-between'>
            <div>
              Plate Transfer:
            </div>
            <div className='font-medium'>
              {docsFormData?.plateTransfer ? 'Yes' : 'No'}
            </div>
          </div>

        </div>


        <div className='flex flex-col w-[100%] text-gray-700 gap-2'>
          {docsFormData?.lien &&
            <div className='flex flex-row justify-between'>
            <div>
              Lien:
            </div>
            <div className='font-medium'>
              {docsFormData?.lien ? "Yes": "No"}
            </div>
          </div>
          }

          {docsFormData?.uploadDate &&
            <div className='flex flex-row justify-between'>
              <div>
                Uploaded Date:
              </div>
              <div className='font-medium'>
                {docsFormData?.uploadDate}
              </div>
            </div>
          }

          {docsFormData?.driverCategory &&
            <div className='flex flex-row justify-between'>
              <div>
               Driver Category:
              </div>
              <div className='font-medium'>
                {docsFormData?.driverCategory}
              </div>
            </div>
          }

          {docsFormData?.basePrice &&
            <div className='flex flex-row justify-between'>
              <div>
                Base Price:
              </div>
              <div className='font-medium'>
                {Number(docsFormData?.basePrice || 0).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              </div>
            </div>
          }

          

          {docsFormData?.additionalFees &&
            <div className='flex flex-row justify-between'>
              <div>
                Additional Fee:
              </div>
              <div className='font-medium'>
                {Number(docsFormData?.additionalFees || 0).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              </div>
            </div>
          }

          {docsFormData?.protectionPackages &&
            <div className='flex flex-row justify-between'>
              <div>
                Protection Packages:
              </div>
              <div className='font-medium'>
                {Number(docsFormData?.protectionPackages || 0).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              </div>
            </div>
          }

          {docsFormData?.extendedWarranties &&
            <div className='flex flex-row justify-between'>
              <div>
                Extended Warranties:
              </div>
              <div className='font-medium'>
                {Number(docsFormData?.extendedWarranties || 0).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              </div>
            </div>
          }
          
        </div>
      </div>
    </div>
  )
}

export default TransactionInformation
